<template>
    <div class="container">
        <b-modal
          :model-value="modAsociaMenu"
          :no-close-on-backdrop="true"
          hide-footer
          hide-header-close
          centered
          size="xl"
          dialog-class="modal-asocia-menu-wide"
          :title="nombreRol || ''"
          header-class="reset-modal-header"
          title-class="reset-modal-title"
          body-class="reset-modal-body"
          class="reset-password-dialog"
        >
            <div class="uniform-modal-body uniform-modal-body--wide">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-item">{{ labels.infoText }}</div>
                </div>
                <div class="menu-association-layout">
                    <div class="menu-sidebar">
                        <div class="menu-sidebar-title">{{ labels.menuListTitle }}</div>
                        <b-button
                          v-for="menu in listadoMenus"
                          :key="menu.id"
                          @click="listaSubmenu(menu?.id)"
                          class="menu-sidebar-item"
                          :class="{ active: selectedMenuId === menu.id }"
                        >
                          {{ menu?.nombre }}
                        </b-button>
                    </div>
                    <div class="menu-content">
                        <div class="menu-content-title">{{ nombreMenu?.nombre || labels.selectMenuHint }}</div>
                        <div class="submenu-box" v-if="listadoSubMenus?.length > 0">
                            <div
                              v-for="submenu in listadoSubMenus"
                              :key="submenu?.id"
                              class="submenu-row d-flex align-items-center justify-content-between"
                            >
                                <div class="submenu-name">{{ submenu?.nombre }}</div>
                                <b-form-checkbox
                                  v-model="submenuSelect"
                                  :value="submenu?.id"
                                  switch
                                  class="submenu-switch mb-0"
                                  @change="asociaSubMenu(submenu?.id)"
                                >
                                  {{ submenuSelect.includes(submenu?.id) ? labels.active : labels.inactive }}
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="no-submenus" v-if="showRow">
                            {{ labels.noRow }}
                        </div>
                    </div>
                </div>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Submenu from '../../services/SubMenu'; 
import Menu from '../../services/Menu'; 
import Roles from '../../services/Roles'; 
import RoleMenu from '../../services/RoleMenu'; 

export default {
    name:"ModalAsociaMenu",
    props:['modAsociaMenu','IdRol'],
    data: () => ({
        listadoMenus: [],
        listadoSubMenus: [],
        listadoSubMenusAsoc: [],
        submenuSelect: [],
        nombreRol: "",
        nombreMenu: "",
        menuSelected: "",
        selectedMenuId: null,
        showRow: false,
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    save : "Guardar",
                    close : "Cerrar",
                    noRow : "No hay registros",
                    active: "Activo",
                    inactive: "Inactivo",
                    infoTitle: "Asociación de menús",
                    infoText: "Selecciona un menu de la barra lateral y activa o desactiva sus submenus.",
                    menuListTitle: "Menus",
                    selectMenuHint: "Selecciona un menu"
                }
            }else{
                return {
                    save : "Save",
                    close : "Close",
                    noRow : "There is not data",
                    active: "Active",
                    inactive: "Inactive",
                    infoTitle: "Menu association",
                    infoText: "Select a menu from the sidebar and toggle its submenus for the role.",
                    menuListTitle: "Menus",
                    selectMenuHint: "Select a menu"
                }
            }
        }
    },
    methods:{
        nameRol(){
            if(this.IdRol != ""){ 
                Roles.getAllRolesById(this.IdRol) 
                .then((res) => { 
                    this.nombreRol = res.data.rolById[0].nombre 
                })
                .catch((error) => {console.log(error)}) 
            }
        },
        listaSubmenu(idMenu){
            // console.log(this.IdRol,idMenu) 
            this.selectedMenuId = idMenu
            this.menuSelected = idMenu 
            Submenu.subMenuByIdMenu(idMenu) 
            .then((res) => { 
                // console.log(res.data.listSubMenu) 
                this.listadoSubMenus = res.data.listSubMenu 
                if(this.listadoSubMenus.length == 0){ 
                    this.showRow = true 
                }else{
                    this.showRow = false 
                }
            })
            .catch((error) => {console.log(error)}) 

            RoleMenu.getSubMenuByRolByMenu(this.IdRol,idMenu) 
            .then((res) => { 
                let submenuChecked = []
                // console.log(res.data.listRolMenu) 
                this.listadoSubMenusAsoc = res.data.listRolMenu 
                this.listadoSubMenusAsoc.forEach((elem) => { 
                    submenuChecked.push(elem.id_submenu) 
                })
                // console.log(numSubmenu) 
                this.submenuSelect = submenuChecked 
            })
            .catch((error) => {console.log(error)}) 

            this.nombreMenu = this.listadoMenus.find((lm) => lm.id == idMenu) 
        },
        asociaSubMenu(subMenuId){
            // console.log(this.IdRol,this.menuSelected,subMenuId) 
            let datos = {
                "idRol" : this.IdRol, 
                "idMenu" : this.menuSelected, 
                "idSubmenu" : subMenuId
            }

            RoleMenu.updateAsociacionRolemenu(datos) 
            .then((res) => { 
                // console.log(res.data.message) 
                this.$toast.success(res.data.message) 
            })
            .catch((err) => {console.log(err)}) 
        },
        cierraModal(){
            this.listadoSubMenus = [] 
            this.submenuSelect = []
            this.selectedMenuId = null
            this.menuSelected = ""
            this.nombreMenu = "" 
            this.showRow = false
            this.$emit('closeModal',false) 
        }
    },
    watch:{
        IdRol:{
            immediate:true,
            handler(){
                this.nameRol()
            }
        }
    },
    mounted(){
        Menu.getAllMenu() 
        .then((res) => { 
            // console.log(res.data.listMenu) 
            this.listadoMenus = res.data.listMenu 
            if (this.listadoMenus.length > 0 && !this.selectedMenuId) {
                this.listaSubmenu(this.listadoMenus[0].id)
            }
        })
        .catch((error) => {console.log(error)}) 
    }
}
</script>
